// extracted by mini-css-extract-plugin
export default {"text":"Activate_text__B54jk","button":"Activate_button__kHOF0"};